import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  en: {
    langToggle: "हिंदी",
    navHome: "Home",
    navReading: "Reading",
    navFeatures: "Features",
    navFaq: "FAQ",
    heroTitle1: "Unlock The Secrets Hidden In Your",
    heroTitle2: "Name & Date of Birth",
    heroSubtitle: "Discover your Personality, Love Life, Future Partner, Career, Money Flow, Hidden Talents and Life Path with AI-powered personalized astrology.",
    heroCta: "✨ Get My Reading",
    trustUsers: "100,000+ Users",
    trustSecure: "Secure Payment",
    trustInstant: "Instant Report",
    howTitle: "How It Works",
    howSubtitle: "Get your personalized reading in 3 simple steps",
    step1Title: "Chat With Us",
    step1Desc: "Share your name, date of birth and question through our premium chat.",
    step2Title: "AI Analysis",
    step2Desc: "Our AI analyzes your birth chart, personality and life path in seconds.",
    step3Title: "Get Your Report",
    step3Desc: "Pay just ₹49 for a 3-minute personalized live session with our Astrologer.",
    insightsTitle: "What You'll Discover",
    insightsSubtitle: "Deep insights powered by advanced astrology",
    insight1Title: "Love & Relationships",
    insight1Desc: "Understand your love patterns, compatibility and relationship direction.",
    insight2Title: "Career & Money",
    insight2Desc: "Discover your ideal career path and money flow potential.",
    insight3Title: "Personality Analysis",
    insight3Desc: "Uncover hidden personality traits and your true strengths.",
    insight4Title: "Future Predictions",
    insight4Desc: "Get insights about upcoming opportunities and life changes.",
    unlockBtn: "Unlock Full Report — ₹49",
    processing: "Processing...",
    testimonialsTitle: "Loved by Thousands",
    testimonial1: "The personality reading was shockingly accurate. It described things about me that even I didn't realize!",
    testimonial2: "Paid ₹49 and got insights that changed how I think about my career. Best money I've ever spent.",
    testimonial3: "The love compatibility analysis was spot on. Recommended to all my friends!",
    faqTitle: "Frequently Asked Questions",
    faq1Q: "How does the reading work?",
    faq1A: "You share your name, date of birth and question. Our AI analyzes your birth chart and generates a personalized reading within seconds.",
    faq2Q: "How long is the chat session?",
    faq2A: "Each session lasts 3 minutes. You can chat with the astrologer and ask questions within this time.",
    faq3Q: "Is my data private?",
    faq3A: "Absolutely. Your data is encrypted and never shared with anyone. We take privacy very seriously.",
    faq4Q: "Is the payment secure?",
    faq4A: "Yes! We use Razorpay, India's most trusted payment gateway. Your payment details are 100% secure.",
    faq5Q: "Can I continue after 3 minutes?",
    faq5A: "Yes! You can upgrade to our Premium plan for ₹99 to get 10 more minutes of chat.",
    ctaTitle: "Ready to Discover Your Future?",
    ctaSubtitle: "Join 100,000+ people who have already unlocked their personalized reading.",
    ctaBtn: "Get Started Now",
    privacy: "Privacy Policy",
    terms: "Terms",
    refund: "Refund Policy",
    disclaimer: "Disclaimer",
    contact: "Contact",
    footerDisclaimer: "© 2026 Vishu Astro. All rights reserved. For entertainment purposes.",
    chatOnline: "Online",
    chatEnded: "Session Ended",
    chatPlaceholder: "Type your message...",
    chatExpiredPlaceholder: "Session expired. Upgrade to continue.",
    connecting: "Connecting to astrologer...",
    sessionEndedTitle: "Continue Your Astrology Session",
    sessionEndedDesc: "Your 3-minute consultation has ended. Continue your personalized AI astrology session for deeper insights and ask more questions.",
    rechargeBtn: "Continue Chat — ₹99",
    backHome: "Back to Home",
    upgradeFeature1: "10 Minutes AI Live Chat",
    upgradeFeature2: "Ask multiple questions",
    upgradeFeature3: "Personalized guidance",
    upgradeFeature4: "Continue from same conversation",
  },
  hi: {
    langToggle: "English",
    navHome: "होम",
    navReading: "रीडिंग",
    navFeatures: "फीचर्स",
    navFaq: "FAQ",
    heroTitle1: "अपने नाम और जन्मतिथि में छिपे",
    heroTitle2: "रहस्य जानें",
    heroSubtitle: "AI-powered ज्योतिष से जानें अपना व्यक्तित्व, प्यार, भावी साथी, करियर, पैसा, छिपी प्रतिभा और जीवन पथ।",
    heroCta: "✨ मेरी रीडिंग शुरू करें",
    trustUsers: "1,00,000+ यूज़र्स",
    trustSecure: "सुरक्षित भुगतान",
    trustInstant: "तुरंत रिपोर्ट",
    howTitle: "कैसे काम करता है",
    howSubtitle: "3 आसान चरणों में अपनी रीडिंग पाएं",
    step1Title: "हमसे चैट करें",
    step1Desc: "प्रीमियम चैट से अपना नाम, जन्मतिथि और सवाल बताएं।",
    step2Title: "AI विश्लेषण",
    step2Desc: "हमारा AI कुछ सेकंड में आपकी कुंडली और व्यक्तित्व का विश्लेषण करता है।",
    step3Title: "रिपोर्ट पाएं",
    step3Desc: "हमारे ज्योतिषी के साथ 3 मिनट के सत्र के लिए सिर्फ ₹49 दें।",
    insightsTitle: "आप क्या जानेंगे",
    insightsSubtitle: "उन्नत ज्योतिष द्वारा गहन अंतर्दृष्टि",
    insight1Title: "प्रेम और रिश्ते",
    insight1Desc: "अपने प्रेम पैटर्न, अनुकूलता और रिश्ते की दिशा समझें।",
    insight2Title: "करियर और पैसा",
    insight2Desc: "अपना आदर्श करियर पथ और धन प्रवाह क्षमता जानें।",
    insight3Title: "व्यक्तित्व विश्लेषण",
    insight3Desc: "छिपे व्यक्तित्व गुण और अपनी असली ताकत जानें।",
    insight4Title: "भविष्य की भविष्यवाणी",
    insight4Desc: "आने वाले अवसरों और जीवन में बदलावों के बारे में जानें।",
    unlockBtn: "पूरी रिपोर्ट अनलॉक करें — ₹49",
    processing: "प्रोसेसिंग...",
    testimonialsTitle: "हज़ारों लोगों का भरोसा",
    testimonial1: "व्यक्तित्व रीडिंग बिल्कुल सटीक थी। इसने मेरे बारे में ऐसी बातें बताईं जो मुझे खुद नहीं पता थीं!",
    testimonial2: "₹49 दिए और करियर के बारे में ऐसी जानकारी मिली जिसने सोच बदल दी।",
    testimonial3: "प्रेम अनुकूलता विश्लेषण बिल्कुल सही था। सभी दोस्तों को सुझाया!",
    faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
    faq1Q: "रीडिंग कैसे काम करती है?",
    faq1A: "आप अपना नाम, जन्मतिथि और सवाल बताएं। हमारा AI कुछ सेकंड में आपकी कुंडली का विश्लेषण करके रिपोर्ट बनाता है।",
    faq2Q: "चैट सत्र कितना लंबा है?",
    faq2A: "प्रत्येक सत्र 3 मिनट का है। आप इस समय में सवाल पूछ सकते हैं।",
    faq3Q: "क्या मेरा डेटा निजी है?",
    faq3A: "बिल्कुल। आपका डेटा एन्क्रिप्टेड है और कभी किसी के साथ साझा नहीं किया जाता।",
    faq4Q: "क्या भुगतान सुरक्षित है?",
    faq4A: "हाँ! हम Razorpay का उपयोग करते हैं, जो भारत का सबसे विश्वसनीय भुगतान गेटवे है।",
    faq5Q: "क्या मैं 3 मिनट बाद जारी रख सकता हूं?",
    faq5A: "हाँ! आप ₹99 में Premium प्लान अपग्रेड करके 10 और मिनट चैट कर सकते हैं।",
    ctaTitle: "अपना भविष्य जानने के लिए तैयार?",
    ctaSubtitle: "1,00,000+ लोगों से जुड़ें जिन्होंने अपनी रीडिंग अनलॉक की है।",
    ctaBtn: "अभी शुरू करें",
    privacy: "गोपनीयता नीति",
    terms: "शर्तें",
    refund: "रिफंड नीति",
    disclaimer: "डिस्क्लेमर",
    contact: "संपर्क",
    footerDisclaimer: "© 2026 Vishu Astro. सर्वाधिकार सुरक्षित। मनोरंजन उद्देश्यों के लिए।",
    chatOnline: "ऑनलाइन",
    chatEnded: "सत्र समाप्त",
    chatPlaceholder: "अपना संदेश लिखें...",
    chatExpiredPlaceholder: "सत्र समाप्त। जारी रखने के लिए अपग्रेड करें।",
    connecting: "ज्योतिषी से जुड़ रहे हैं...",
    sessionEndedTitle: "अपना ज्योतिष सत्र जारी रखें",
    sessionEndedDesc: "आपका 3 मिनट का परामर्श समाप्त हो गया है। गहरी जानकारी और अधिक प्रश्नों के लिए जारी रखें।",
    rechargeBtn: "चैट जारी रखें — ₹99",
    backHome: "होम पर वापस जाएं",
    upgradeFeature1: "10 मिनट AI लाइव चैट",
    upgradeFeature2: "कई सवाल पूछें",
    upgradeFeature3: "व्यक्तिगत मार्गदर्शन",
    upgradeFeature4: "उसी बातचीत से जारी रखें",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState("en");
  const toggleLanguage = useCallback(() => setLanguage(p => (p === "en" ? "hi" : "en")), []);
  const t = useCallback((key) => translations[language]?.[key] || translations.en[key] || key, [language]);
  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
